import { observable, makeObservable, action } from 'mobx';
import { handleSkillGroup, getSkillList } from '@/utils/Page';
import { third_json_handler } from '@/utils/Page/constant';
import { handleGetSkillDetail } from '@/api/grt/ai';
import { defaultPlaceholder } from '@/utils/Page/constant';
import grtAiStore from '.';
export const isUsualSkillAvailable = (skillList) => {
    let res = skillList.find((skill) => skill.left_side === 1 && String(skill.ability_id) === '-1');
    return res;
};
// 代码改造---未使用
class SkillStore {
    constructor() {
        makeObservable(this);
    }
    @observable skillType = ''; //技能类型
    @action
    setSkillType = (data) => {
        this.skillType = data;
    };
    @observable skillAvailable = true; //技能是否可用
    @action
    setSkillAvailable = (data) => {
        this.skillAvailable = data;
    };
    @observable skillPreQuestion = []; //技能前置问题
    @action
    setSkillPreQuestion = (data) => {
        this.skillPreQuestion = data;
    };
    @observable skillList = [{ apartList: [], unApartList: [] }]; //技能列表
    @action
    setSkillList = (data) => {
        this.skillList = data;
    };
    @observable originSkillList = []; //技能列表--未处理
    @action
    setOriginSkillList = (data) => {
        this.originSkillList = data;
    };
    @observable curSkill = {}; //当前技能
    @action
    changeCurSkill = (data) => {
        this.curSkill = data;
    };
    @observable curPlugin = []; //当前插件
    @action
    setCurPlugin = (data) => {
        this.curPlugin = data;
    };
    setCurSkill = (targetSkill) => {
        this.setCurPlugin([]);
        let resultSkill = {};
        //如果传入的targetSkill不为空，判断是否存在该技能
        if (targetSkill?.ability_id) {
            let skill = this.originSkillList.find((ele) => {
                return String(ele.ability_id) === String(targetSkill?.ability_id);
            });
            if (Number(skill?.ability_id) === -1) {
                skill.default_prompt = defaultPlaceholder;
            }
            //技能不存在 或者不显示
            if (!skill || skill.left_side === 0) {
                this.setSkillAvailable(false);
            } else if (skill?.left_side === 2) {
                //对话框上方的技能
                if (isUsualSkillAvailable(this.originSkillList)) {
                    this.setSkillAvailable(true);
                } else {
                    this.setSkillAvailable(false);
                }
            } else {
                this.setSkillAvailable(true);
            }

            resultSkill = {
                ...targetSkill,
                ...skill
            };
        } else {
            //传入的是{}，开启新会话时，要改变状态
            this.setSkillAvailable(true);
        }
        //设置技能类型
        this.setSkillType(this.getSkillType(resultSkill?.ability_id));
        this.changeCurSkill(resultSkill);
        if (resultSkill?.pre_question_json) {
            this.setSkillPreQuestion(resultSkill?.pre_question_json || []);
        } else {
            this.setSkillPreQuestion([]);
        }
    };
    //获取技能列表--处理成隔离及未隔离分组
    getGroupSkillList = (scene_setting, scene_id, toolList = [], isLogin = false) => {
        let res = getSkillList(scene_setting, scene_id, isLogin);
        let urlSkillId = grtAiStore.searchParams?.get('skill_id');
        let side = grtAiStore.side;
        this.setOriginSkillList(res);
        let { apartList = [], unApartList = [] } = handleSkillGroup(res, toolList, side);
        let nextCurSkill = null;
        if (apartList.length > 0) {
            nextCurSkill = apartList[0];
        }
        if (urlSkillId) {
            let urlSkillInfo = res.find((item) => item.ability_id === urlSkillId);
            if (urlSkillInfo) {
                nextCurSkill = urlSkillInfo;
            }
        }
        if (nextCurSkill) {
            this.setCurSkill(nextCurSkill);
        }
        this.setSkillList({
            apartList,
            unApartList
        });
    };
    //获取指定技能
    getTargetSkill = (skillId) => {
        let temSkill = this.originSkillList.find((ele) => ele.ability_id === skillId);
        return temSkill;
    };
    getSkillType = (skillId) => {
        let temSkill = this.originSkillList.find((ele) => ele && String(ele.ability_id) === String(skillId));
        let handler = temSkill?.third_json?.handler || '';
        if (third_json_handler[handler]) {
            return third_json_handler[handler];
        }
        return 'usual';
    };
    //获取技能
    isTargetSkillType = (skillId, type) => {
        let temSkill = this.originSkillList.find((ele) => ele && String(ele.ability_id) === String(skillId));
        if (temSkill?.third_json?.handler === type) {
            return true;
        }
        return false;
    };
    isAiReviewType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.ai_evaluation);
    };
    isDeerFlowType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.deerflow);
    };
    isChatBIype = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.chatbi);
    };
    isAipptType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.aippt);
    };
    isFileChatType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.file_chat);
    };
    isMultimodalLearningType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.multimodal);
    };
    isCaseSimulationType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.case_simulation);
    };
    isCourseRecommendType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.recommend_course);
    };
    isIntelligentQAType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.intelligent_qa);
    };
    isPersonalRecommendType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.personalized_recommendation);
    };
    isVideoQAType = (skillId) => {
        return this.isTargetSkillType(skillId, third_json_handler.video_qa);
    };
    getSkillDetail = async (skill_id) => {
        let res = await handleGetSkillDetail(skill_id);
        if (res && res.data) {
            return res.data;
        }
        return null;
    };
    isSkillNeedLogin = (skill) => {
        let targetSkill = skill || this.curSkill;
        // 🔥 优化：根据 login_restrict 字段判断是否需要登录
        // login_restrict = 0: 不需要登录
        // login_restrict = 1: 需要登录
        // 如果字段不存在，默认需要登录
        if (targetSkill?.login_restrict === 0) {
            return false; // 明确标记为不需要登录
        }
        if (targetSkill?.login_restrict === 1) {
            return true; // 需要登录
        }
        // 兜底：如果没有 login_restrict 字段，默认需要登录（保持向后兼容）
        return true;
    };
    isNoFooterSkills = () => {
        let { curSkill } = this;
        let skillId = curSkill?.ability_id;

        return (
            this.isDeerFlowType(skillId) ||
            this.isFileChatType(skillId) ||
            this.isCaseSimulationType(skillId) ||
            this.isAiReviewType(skillId) ||
            this.isCourseRecommendType(skillId) ||
            this.isPersonalRecommendType(skillId)
        );
    };
}
const SkillStoreInstance = new SkillStore();
export default SkillStoreInstance;
